import {Injectable} from "@angular/core";
import {DeployedEnv} from "../../../common/env/index";

@Injectable()
export class ReloadAppProvider{
	constructor(private  env:DeployedEnv){}

	// reloading the app requires a hard reload since:
	// a. angular modules are not unloaded when they go out of scope (including lazy loaded modules)
	// b. we want to make sure we clear all providers state data
	// c. we want to clear all memory leaks (ours and framework)
	public reloadApplication(){
		window.location.href = this.env.baseResourcesUrl;
	}
}
